import { Close } from "@mui/icons-material";
import { Box, Dialog, IconButton, Paper, Stack } from "@mui/material";
import dayjs from "dayjs";
import { graphql, useStaticQuery } from "gatsby";
import React, { useState } from "react";
import { useMount } from "react-use";
import { trackNewsletter } from "../../helpers/analytics";

const PopupBanner = () => {
  const { prismicModal } = useStaticQuery(graphql`
    query {
      prismicModal(uid: { eq: "modal.homepage" }) {
        data {
          title {
            html
          }
          text {
            html
          }
          header {
            alt
            url
          }
          cta_text {
            html
          }
          cta_link {
            url
          }
          published
        }
      }
    }
  `);

  const [dialog, setDialog] = useState(false);

  const { data: modalDialog } = prismicModal;

  const { title, text, header, cta_text, cta_link } = modalDialog;

  useMount(() => {
    if (!modalDialog.published) {
      return;
    }

    const ends = dayjs();
    const starts = localStorage.getItem("lastVisited");

    if (!starts || ends.diff(starts, "days") > 30) {
      localStorage.setItem("lastVisited", dayjs());
      setDialog(true);
    }
  });

  return (
    <Dialog onClose={() => setDialog(false)} open={dialog}>
      <Paper component={Stack}>
        <IconButton
          onClick={() => setDialog(false)}
          sx={{
            ml: "auto",
            mt: "5px",
            mr: "5px",
          }}
        >
          <Close />
        </IconButton>

        <Stack
          sx={{
            margin: { xs: "0 20px", sm: "0 75px" },
            padding: { xs: "30px 0px", sm: "0 0px 30px" },
          }}
        >
          <Stack
            sx={{
              maxWidth: "370px",
              width: "100%",
              alignItems: "center",
            }}
          >
            <Box
              component="img"
              src={header?.url}
              alt={header?.alt}
              sx={{
                maxWidth: "277px",
                maxHeight: "180.8px",
                width: "100%",
                height: "100%",
                marginBottom: "14px",
              }}
            />

            <Box
              dangerouslySetInnerHTML={{ __html: title?.html }}
              sx={{
                "& h1,h2,h3,h4,h5,h6": {
                  fontWeight: 900,
                  fontSize: { xs: "32px", md: "32px" },
                  lineHeight: 1.25,
                  textAlign: "center",
                  color: "#3f119b",
                  marginBottom: "10.5px",
                },
              }}
            />

            <Box
              dangerouslySetInnerHTML={{ __html: text?.html }}
              sx={{
                fontSize: "18px",
                lineHeight: "1.33",
                textAlign: "center",
                color: "#626972",
                maxWidth: "362px",
              }}
            />

            <Box
              component="a"
              href={cta_link?.url}
              onClick={trackNewsletter}
              sx={{
                maxWidth: "268px",
                height: { xs: "67px", md: "75px" },
                padding: {
                  xs: "23.9px 20px 23.1px 20px",
                  md: "25.9px 56px 26.1px 56px",
                },
                borderRadius: "10px",
                backgroundColor: "#6a27e8",
                fontSize: { xs: "16px", md: "18px" },
                fontWeight: "bold",
                lineHeight: 1.2,
                textAlign: "center",
                color: "white",
                margin: "30px auto 0px",
                textTransform: "uppercase",
                cursor: "pointer",
                boxShadow: "0 15px 25px 0 rgba(106, 39, 232, 0.2)",
                textDecoration: "none",

                "&>p": {
                  margin: "0px",
                },
                "&:hover": {
                  backgroundColor: "#3f119b",
                },
              }}
            >
              <Box dangerouslySetInnerHTML={{ __html: cta_text?.html }} />
            </Box>
          </Stack>
        </Stack>
      </Paper>
    </Dialog>
  );
};

export default PopupBanner;
